var ZagBreakpoints = ZagBreakpoints || {

    GetViewport: function () {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    },

    GetBreakpoint: function () {
        for (var key in this.Breakpoints) {
            if (key !== "compareArrays" && key !== "indexOf") {
                if (this.Breakpoints[key].matches) {
                    return key.toString();
                }
            }
        }
    },

    Breakpoints: {
        xs: window.matchMedia('(max-width: 575.98px)'),
        sm: window.matchMedia('(min-width: 576px) and (max-width: 767.98px)'),
        md: window.matchMedia('(min-width: 768px) and (max-width: 991.98px)'),
        lg: window.matchMedia('(min-width: 992px) and (max-width: 1199.98px)'),
        xl: window.matchMedia('(min-width: 1200px) and (max-width: 1399.98px)'),
        xxl: window.matchMedia('(min-width: 1400px)')
    }
};

(function ($) {
    "use strict";

    $.BPEvents = function (options) {

        this.init = function (options) {
            this.options = $.extend({}, $.BPEvents.defaultOptions, options);
            if (window.matchMedia) {
                for (var key in ZagBreakpoints.Breakpoints) {
                    if (key !== "compareArrays" && key !== "indexOf") {
                        ZagBreakpoints.Breakpoints[key].addListener($.proxy(this.bpChange, this));
                        if (ZagBreakpoints.Breakpoints[key].matches) {
                            $(document).trigger('enter-' + key);
                        }
                    }
                }
            }
        };

        this.bpChange = function (media) {
            var type = (media.matches) ? 'enter' : 'leave';
            document.dispatchEvent(new CustomEvent(type + '-' + this.getBP(media)));
            //$(document).trigger(type + '-' + this.getBP(media));
        };

        this.getBP = function (media) {
            for (var key in ZagBreakpoints.Breakpoints) {
                if (ZagBreakpoints.Breakpoints[key].media === media.media) { return key; }
            }
        };

        if (ZagBreakpoints) {
            this.init(options);
        }
    };

    $.fn.BPEvents = (function (options) {
        (new $.BPEvents(options));
    });

    $.BPEvents.defaultOptions = {};

    $.BPEvents();

})(jQuery);
